'use client';

import iconCharacter from '@/assets/images/icons/icon-character.png';
import iconComa from '@/assets/images/icons/icon-coma.png';
import { MaterialFilter, type MaterialFilterTabValue } from '@/types';
import clsx from 'clsx';
import ImageView from '../ImageView/ImageView';
import styles from './MaterialFilterTabs.module.scss';

export type { MaterialFilterTabValue };

function MaterialFilterTabs({
  activeTab,
  onTabChange,
  filterTabColor = 'gray200',
}: {
  activeTab: MaterialFilterTabValue;
  onTabChange: (tab: MaterialFilterTabValue) => void;
  filterTabColor?: 'gray200' | 'white';
}) {
  return (
    <div
      className={clsx(styles.filterTabs, {
        [styles.filterTabsGray200]: filterTabColor === 'gray200',
        [styles.filterTabsWhite]: filterTabColor === 'white',
      })}
    >
      <button
        type='button'
        className={`${styles.filterTab} ${activeTab === MaterialFilter.ALL ? styles.filterTabActive : ''}`}
        onClick={() => onTabChange(MaterialFilter.ALL)}
      >
        すべて
      </button>
      <button
        type='button'
        className={`${styles.filterTab} ${activeTab === MaterialFilter.CHARACTER ? styles.filterTabActive : ''}`}
        onClick={() => onTabChange(MaterialFilter.CHARACTER)}
      >
        <span className={`${styles.filterTabIcon} ${styles.filterTabIconCharacter}`}>
          {/* 静的画像をNext.jsのImageコンポーネントで使用するとパスが解決できず読み込めないので、html標準のimageタグを使う */}
          <ImageView src={iconCharacter.src} alt='' isFreeSize={true} />
        </span>
        <p className={styles.filterTabText}>キャラクター</p>
      </button>
      <button
        type='button'
        className={`${styles.filterTab} ${activeTab === MaterialFilter.FRAME ? styles.filterTabActive : ''}`}
        onClick={() => onTabChange(MaterialFilter.FRAME)}
      >
        <span className={`${styles.filterTabIcon} ${styles.filterTabIconComa}`}>
          {/* 静的画像をNext.jsのImageコンポーネントで使用するとパスが解決できず読み込めないので、html標準のimageタグを使う */}
          <ImageView src={iconComa.src} alt='' isFreeSize={true} />
        </span>
        <p className={styles.filterTabText}>コマ</p>
      </button>
    </div>
  );
}

export default MaterialFilterTabs;
